import React from 'react';
import { Modal } from 'react-bootstrap';

import EncabezadoImp from './encabezadoImp.jsx';
import ArticulosSuc from './detalleSucursal.jsx';
import IframePrint from '../../../../components/UI/IframePrint/IframePrint';
import { Fragment } from 'react';

const despacharOrdenes = props => {

    const { articulos, articulosAp, tipoEntrega, ParametroGenerales, sucApoyo, R_Disponible, Re_Impreso, OrdenId, Disponible_Positivo, empresa_nombre,
        instrucciones_entrega } = props;
    const iframePrintId = "ordenTicket";

    const fontStyles = { fontSize: '14px', fontFamily: 'monospace' };
    const apoyoHtml = sucApoyo.map((suc_Id, index) => {
        return <Fragment>
            <div style={{ textAlign: 'center' }}>
                <hr style={{ borderWidth: "1px", borderStyle: "dashed", width: '50%', marginTop: '1.5rem', marginBottom: '1.5rem' }} />
            </div>
            <ArticulosSuc key={suc_Id} articulos={articulosAp} sucursal={suc_Id} />
        </Fragment>
    });

    const bodyHtml = <div style={{ width: "300px", maxWidth: "300px" }}>
        <EncabezadoImp
            articulos={articulos}
            tipoEntrega={tipoEntrega}
            R_Disponible={R_Disponible}
            Disponible_Positivo={Disponible_Positivo}
            Re_Impreso={Re_Impreso}
            ParametroGenerales={ParametroGenerales}
            OrdenId={OrdenId}
            empresa_nombre={empresa_nombre}
            instrucciones_entrega={instrucciones_entrega}
        />
        {apoyoHtml}
        <p style={{ ...fontStyles, textAlign: 'center', marginTop: '1.5rem' }}>----- Última Línea -----</p>
    </div>;

    return (
        <Modal show={props.show} onHide={props.onClickCancelar} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title><h5 className="modal-title" id="exampleModalLabel">Impresión de la Orden</h5></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="container">
                    <div className="row align-items-center justify-content-center customScrollbar" style={{ maxHeight: '450px', overflowY: 'auto' }}>
                        {bodyHtml}
                        <IframePrint id={iframePrintId} reactElement={bodyHtml} />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={props.onClickCancelar}>Cancelar</button>
                <button type="button" className="btn btn-primary" onClick={() => {
                    window.frames[iframePrintId].focus();
                    window.frames[iframePrintId].print();
                }}>Imprimir</button>
            </Modal.Footer>
        </Modal>
    )
}

export default despacharOrdenes;